import {safeLocalStorage, safeSessionStorage} from '../utils/storage';
import {CurrentUserResponse, UserProgressResponse} from "../interfaces/sdk";
import {FormattedUserProgress, formatUserProgress} from "../utils/userProgress";
import { pageInfo } from '../global';
import {apiClient} from "../httpClient";

export const tokenTypes = ['development', 'production', 'preview'] as const;
export type TokenType = typeof tokenTypes[number] | string

export const fetchCurrentUser = async (): Promise<CurrentUserResponse> => {
  return apiClient.get(`/sdk/current-user`, {params: { page_info_url: pageInfo.url }})
}

export const fetchUserProgress = async (): Promise<FormattedUserProgress> => {
  const data = await apiClient.get<UserProgressResponse>(`/sdk/user-progress`, {params: { page_info_url: pageInfo.url }})

  return formatUserProgress(data.userProgress)
}

export const setAuthAxiosHeaders = (token: string, appKeyId: string) => {
  apiClient.setHeaders({
    Authorization: `Bearer ${token}`,
    'gl-app-key-id': appKeyId,
  })
}

type LocalUser = {
  accessToken: string,
  refreshToken: string,
  appSlug: string,
  appKeyId: string
}

export const saveUserLocally = (isSessionStorage: boolean, data: LocalUser) => {
  if (isSessionStorage) {
    safeSessionStorage.setItem(`${data.appSlug}_user`, JSON.stringify(data))
  } else {
    safeLocalStorage.setItem(`${data.appSlug}_user`, JSON.stringify(data))
  }
}

export const getLocalUser = (isSessionStorage: boolean, appSlug: string) => {
  const key = `${appSlug}_user`
  if (isSessionStorage) {
    //Remove user from localstorage if it already exists, since using session storage
    if (safeLocalStorage.getItem(key)) {
      safeLocalStorage.removeItem(key)
    }
    return safeSessionStorage.getItem(key)
  }
  return safeLocalStorage.getItem(key)
}

export const removeLocalUser = (isSessionStorage: boolean, appSlug: string) => {
  if (isSessionStorage) {
    safeSessionStorage.removeItem(`${appSlug}_user`)
  } else {
    safeLocalStorage.removeItem(`${appSlug}_user`)
  }
}

export const setAuthAxiosLocaleHeader = (lang: string, region: string) => {
  apiClient.setHeaders({
    lang,
    region: region || null
  })
}
